export default {
    name_shq: 'ARBK',
    name_en: 'ARBK',
    name_sr: 'ARBK',
    fullName: 'ARBK',
    url: '',
    author: {
        name: '',
        profile_url: '',
    },
    contacts: {
        address: 'Rruga "Arbënor e Astrit Dehari” Lagja Spitalit 10000 Prishtinë',
        email: 'infoarbk@rks-gov.net',
        phone: '+381 (0)38 200-36548',
    },
};
